export default "__VITE_ASSET__BSSgbL68__"